import React from "react";
import { HiddenVisually } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
export default function FlightCardPositionAnnouncement({ index, total }) {
    const i18n = useI18n();
    return (React.createElement(HiddenVisually, null, `${i18n.trans(t("a11y_flights_search_card_begin"))} ${i18n.trans(t("a11y_aria_label_pagination", { variables: { page_num: index + 1, num_pages: total } }))}`));
}
